<script>
import { mapGetters } from 'vuex'

export default {
  component: 'fetch-story',

  props: {
    route: {
      type: String,
      default() {
        return ''
      },
    },
    offset: {
      type: Number,
      default() {
        return null
      },
    },
    limit: {
      type: Number,
      default() {
        return null
      },
    },
    perPage: {
      type: Number,
      default() {
        return 100
      },
    },
    params: {
      type: Object,
      default() {
        return {}
      },
    },
    collection: {
      type: Array,
      default() {
        return []
      },
    },
    entry: {
      type: String,
      default() {
        return ''
      },
    },
  },

  data() {
    return {
      pages: 0,
      total: 0,
      loading: true,
      output: [],
    }
  },

  computed: {
    ...mapGetters({
      region: 'globals/getRegion',
    }),
  },

  async created() {
    if (this.route || (this.params || {}).by_uuids) {
      await this.fetchAllStories({
        route: this.route,
        limit: this.limit,
        per_page: this.perPage,
        params: {
          sort_by: 'first_published_at:desc',
          by_uuids: null,
          ...this.params,
        },
      })
    }
    this.output.push(...this.collection)
  },

  methods: {
    async fetchStory(payload) {
      await this.$store.dispatch('loading/startBusyState')

      return await this.$storyapi
        .get('cdn/stories', {
          starts_with: payload.route,
          page: payload.index || 1,
          per_page: payload.per_page,
          version: 'published',
          is_startpage: 0,
          ...payload.params,
        })
        .then((response) => {
          if (!this.total) {
            this.total = response.total
            this.pages = Math.ceil(this.total / payload.per_page)
          }
          this.loading = false
          this.$store.dispatch('loading/stopBusyState')
          return response.data.stories
        })
        .catch((response) => {
          this.loading = false
          return response
        })
    },
    async fetchAllStories(payload) {
      // get first page.
      await this.fetchStory({
        per_page: payload.limit || payload.per_page,
        route: payload.route,
        params: payload.params,
      })
        .then((results) => {
          this.updateCollection(results)
        })
        .catch((response) => {
          return response
        })

      // loop over other pages.
      if (!payload.limit && this.pages > 1) {
        for (let page = 2; page <= this.pages; page++) {
          await this.fetchStory({
            index: page,
            per_page: payload.per_page,
            route: payload.route,
            params: payload.params,
          })
            .then((results) => {
              this.updateCollection(results)
            })
            .catch((response) => {
              return response
            })
        }
      }

      return this.output
    },
    updateCollection(results) {
      this.output.push(
        // map over each result and check array is not empty, then merge with the original collection.
        ...results
          .map((item) => ({
            url: item.full_slug,
            tags: item.tag_list,
            created_at: item.created_at,
            published_at: item.published_at,
            first_published_at: item.first_published_at,
            ...item[this.entry],
          }))
          .filter(() => true)
          .slice(this.offset)
      )
    },
  },

  render() {
    return this.$scopedSlots.default({
      loading: this.loading,
      collection: this.output,
    })
  },
}
</script>
